<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <DxToolbar class='select-group'>
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>년도 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxYearOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
    </DxToolbar>
    <DxPivotGrid
      ref="resultPivot"
      :allow-sorting-by-summary="true"
      :allow-sorting="true"
      :allow-filtering="true"
      :allow-expand-all="true"
      :show-borders="true"
      :show-column-grand-totals="false"
      :show-row-grand-totals="false"
      :show-row-totals="false"
      :show-column-totals="true"
      :data-source="dataSource"
      :height="pivotHeight"
      @cell-prepared = 'onCellPrepared'
      @cell-click = 'onCellClick'
    >
      <DxFieldChooser
        :enabled="true"
        :height="400"
      />
      <DxExport
        :enabled="true"
        :file-name="excelTitle"
      />
    </DxPivotGrid>

    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
// import { DxSelectBox, DxCheckBox, DxTextBox, DxDateBox, DxButton } from 'devextreme-vue'
import { DxPivotGrid, DxFieldChooser, DxExport } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'

export default {
  name: 'monthSummary',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      thisYear: null,
      selectBoxYearOptions: null,
      dailyStatus: null,
      dataSource: null,
      excelTitle: null,
      pivotHeight: null
    }
  },
  props: {
    pType: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  components: {
    Loading,
    DxPivotGrid,
    DxFieldChooser,
    DxToolbar,
    DxItem,
    DxExport
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.init()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    init () {
      this.thisYear = AppLib.getThisYear()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshDataGrid(this.thisYear)
        }
      }
      this.refreshDataGrid(this.thisYear)
    },
    onCellClick (e) {
      if (e.area === 'column' && e.rowIndex === 0 && e.columnIndex === 0) { e.cancel = true }
      if (e.area === 'row' && e.cell.text.indexOf('7.') < 0) { e.cancel = true }
    },
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
    },
    makeDaily (dailyStatus) {
      if (dailyStatus.length === 0) {
        this.setInitDataSource()
        return
      }
      let timeStamp
      for (let i = 1; i <= 12; i++) {
        timeStamp = AppLib.getTimestampFromformat(this.thisYear, i, 1)
        let where = this.$_.findWhere(dailyStatus, { 생산기준일: timeStamp, 품번: dailyStatus[0].품번 })
        if (where === undefined) {
          const temp = {
            생산기준일: timeStamp,
            품명: dailyStatus[0].품명,
            품번: dailyStatus[0].품번,
            차종: dailyStatus[0].차종,
            양품: 0
          }
          dailyStatus.push(temp)
        }
      }
      this.setInitDataSource()
    },
    refreshDataGrid (year) {
      this.isLoading = true
      this.excelTitle = `${year}-${this.title}`
      const param = {
        'fromDate': `${year}-01-01`,
        'toDate': `${year}-12-31 23:59:59`,
        'pType': this.pType
      }
      this.$_sp.runNoEncodeFindProc('spFindAllYearProductionResultByPtype', param)
        .then((data) => {
          this.isLoading = false
          this.dailyStatus = this.$_sp.MakeModel(data)
          this.makeDaily(this.dailyStatus)
          this.pivotHeight = (screen.height - 250) * 0.95
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '',
            dataField: '차종',
            area: 'row',
            width: '60',
            expanded: true
          },
          {
            caption: '',
            dataField: '품번',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '생산기준일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'year',
            expanded: true
          },
          {
            dataField: '생산기준일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month'
          },
          {
            caption: '양품',
            dataField: '양품',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }

        ],
        store: this.dailyStatus
      })
    }
  }
}
</script>

<style lang="scss">

</style>
